import { render, staticRenderFns } from "./AltaPrecios.vue?vue&type=template&id=28648595"
import script from "./AltaPrecios.vue?vue&type=script&lang=js"
export * from "./AltaPrecios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports